import React from 'react';
import {useSelector} from "react-redux";

const ImportFeedback = (props) => {
    const importFeedback = useSelector(state => state.configuratorStateReducer.importFeedback);
    const displayFeedback = () => {
        return importFeedback.map(i => <div>{i}</div>)
    }
    return (
        <div>
            { displayFeedback() }
        </div>
    )
}

export default ImportFeedback;